import React, {useEffect, useState} from 'react'
import { Row, Col, Card, Tooltip} from 'antd'
import { LOGIN_PAGE } from '../../../../../../constants/constants'
import { CountdownCircleTimer } from "react-countdown-circle-timer"

import { useActions } from '../../../../../hooks/useActions'
import { changeRoute, changeTab,cancelAsanSign } from 'store/actions/login'

import { connect } from 'react-redux'

import '../sidebar.scss'
import './office.scss'

import asanLogo from 'assets/images/icons/asan-logo.png'
import questionMark from 'assets/images/icons/question.png'
import { useTranslation } from 'react-i18next';
import messageList from "assets/locales/translate.json";
import {getMessageList} from "../../../../../services/info";
import CustomTooltip from "components/Tooltip";

const formatRemainingTime = (time: number) => {
  const minutes = Math.floor((time % 1200) / 60);
  const seconds = time % 60;


  return `0${minutes}:${seconds == 0  || seconds< 10 ? `0${seconds}` : seconds}`;
}

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <div className="timer"></div>
  }

  return (
    <div className="timer">
      <div className="value">{formatRemainingTime(remainingTime)}</div>
    </div>
  );
};
const OfficeEntrance: React.FC = ({verification ,messageList}) => {
  const {t} = useTranslation();
  const { cancelAsanSign, changeRoute,changeTab  } = useActions()
  const language = localStorage.getItem("i18nextLng")
  const [textArray, setTextArray] = useState([])
  const fetchessageData = async () => {
    let text = messageList?.result !== undefined ? (language=="az" ? messageList.result.find(text=> text.messageKey === 'INFO.NEW_PASS')?.textAZE :
        language=="ru" ?  messageList.result.find(text=> text.messageKey === 'INFO.NEW_PASS')?.textRU : language=="en" ?  messageList.result.find(text=> text.messageKey === 'INFO.NEW_PASS')?.textENG :"") : "";
    const array_print = text.split("|");
    setTextArray(array_print)
  };

  useEffect(() => {
    fetchessageData()
  }, [messageList,language])

  const TooltipMessage = `
    ${
      textArray.map((line:any,index:number) => {

        return(

            line.startsWith('http') ?
                `<a href=${line} key=${index} > ${line} </a>`
                :
                `<p key=${index}> ${line} </p>`
        )
      }).join('')
  }
    `
  const resetForm = () => {
    // cancelAsanSign()
    // inputRef.current.__clearvalues__()
    changeRoute(0)
    changeTab(3)
  }
  return (
    <Row>
      <Col className="office-card login-form">
        <h3>{t(LOGIN_PAGE.TITLE)}</h3>
        <Card>
          <ul className='office-card__list'>
            <li><img src={asanLogo} alt='asan-logo' /></li>
            <li>
              <CustomTooltip  id='verificationTooltip' overlayClassName='login-tooltip' title={TooltipMessage} placement="top">
                <img src={questionMark} alt='question-mark' />
              </CustomTooltip>
            </li>
          </ul>
          <p>{t(LOGIN_PAGE.MESSAGE)}</p>
          <div className='office-card__statistics mt-15 mb-15'>{t("modal.controlCode")} 
          <span>{verification}</span>
          </div>
          <div className='countdown'>
            <CountdownCircleTimer
              isPlaying
              duration={120}
              size={80}
              strokeWidth={3}
              colors={[["#015cd1"]]}
              onComplete={resetForm}
            >
              {renderTime}
            </CountdownCircleTimer>
          </div>
        </Card>
      </Col>
    </Row>
  )
}
const mapStateToProps = (state: any) => ({
  verification: state.token && state.token.tokenData.result.data.gniAuthResponseType.verfication,
  messageList: state.home.messageList,
})
const mapDispatchToProps = { changeRoute, changeTab, cancelAsanSign, getMessageList }

export default connect(mapStateToProps, mapDispatchToProps)(OfficeEntrance)

